export default __webpack_public_path__ + "static/media/order-fail.9c2a5db6.gif";